import apiClient from "../client";
import { API_ENDPOINTS } from "../endpoints";
import type {
  ApiResponse,
  CreateReportPayload,
  Report,
} from "../interface";

export const reportService = {
  async create(payload: CreateReportPayload) {
    const response = await apiClient.post<ApiResponse<Report>>(
      API_ENDPOINTS.reports,
      payload
    );

    return response.data;
  },
};